import { cn, cva, type VariantProps } from 'noddi-ui-common';

export const cardVariants = cva(cn('rounded-xl border p-5 text-card-foreground shadow-xs'), {
  variants: {
    variant: {
      // Each variant also publishes its fill as --ambient-surface so sticky descendants
      // (e.g. the NoddiTable toolbar) match the card instead of the page canvas.
      primary: cn('border-border bg-card [--ambient-surface:var(--card)]'),
      secondary: cn('border-primary bg-card-light-background [--ambient-surface:var(--card-light-background)]')
    }
  },
  defaultVariants: {
    variant: 'primary'
  }
});

export type CardVariantProps = VariantProps<typeof cardVariants>;
